<!-- <div class="modal-backdrop fade" *ngIf="isVisible"></div> -->
<div class="modal-backdrop fade " *ngIf="isVisible" [class.show]="isVisible"></div>
<div class="modal fade" *ngIf="isVisible" [ngClass]="{'show displayBlock' : isVisible}"
  [class.displayBlock]="isVisible">
  <div class="modal-dialog signin-modal">
    <div class="modal-content">

      <div class="card p-0 signin-card ">
        <div class="row g-0 h-100">
          <div class="col-md-5 h-100">
            <!---DO NOT REMOVE THIS COMMNENTED HTML CODE--->
            <div class="signin-info h-100 d-flex justify-content-around flex-column align-items-center"
              [ngClass]="{'LoginRequired': this.userRestrict}">
              <h1>
                Tenders Made Easy <br />
                To Search
              </h1>
              <h2>
                Search any tender by Location, Category, Organization, High
                Value, Low value, Fresh Bid
              </h2>
              <img loading="lazy" src="https://d1tiqtcifmy0l7.cloudfront.net/prod/icons/signin-1.svg" alt="" />
            </div>
          </div>
          <div class="col-md-7">
            <button type="button" class="btn-close-1 close pull-right d-flex align-items-center jusity-content-center"
              aria-label="Close" (click)="closeModal()">
              <i class="sprite-img-header-footer black-cross-circle"></i>
            </button>
            <div
              class="card-body signin-button-section h-100 d-flex align-items-start justify-content-center jusity-content-center">
              <div class="text-start w-100">
                <!---DO NOT REMOVE THIS COMMNENTED HTML CODE--->
                <div *ngIf="userRestrict" class="exhausted-limit-badge">
                  <img src="./assets/images/i_icon.svg" alt="">
                  <span>You have exhausted your daily free search limit</span>
                </div>
                <h5 class="card-title">Login <span> Or</span> Sign Up</h5>
                <div *ngIf="!userRestrict">
                  <p class="card-text" *ngIf="!isDownloadDoc">
                    To get personalised experience and easy transaction
                  </p>
                  <p class="card-text" *ngIf="isDownloadDoc">
                    To download the tender document free of cost
                  </p>
                </div>
                <p class="card-text" *ngIf="userRestrict">
                  Log in now for all tender access on the website!
                </p>

                <div class="mb-3">
                  <input type="text" [(ngModel)]="mobileNumber" class="form-control input-1" placeholder="Mobile Number"
                    maxlength="10" (input)="onInputChange()" [ngClass]="{'is-invalid': !isNumeric(mobileNumber)}"
                    (keypress)="restrictNonNumeric($event)" />
                </div>

                <div *ngIf="otpIncorrect" class="exhausted-error-message">
                  {{ errorMessage }}
                </div>


                <div class="termbox mb-10">
                  <img src="/assets/images/lock-fill.svg" />
                  <a href="/pages/terms-and-conditions" target="_blank"
                    title="Know the Terms & Conditions Before Applying"> View Terms & Conditions,</a>
                  <a href="/pages/privacy-policy" target="_blank" title="Privacy Policy"> Privacy Policy</a>
                </div>

                <div class="form-check mb-20">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="whatsappConsent"
                   />
                  <label class="form-check-label" for="updatesOnWhatsapp">
                    Also get updates on <i class="sprite-img-list whatsapp-icon-green whatsapp-icon"></i> WhatsApp
                  </label>
                </div>


                <div class="d-grid gap-2">
                  <button class="btn red-btn" [disabled]="!isSignupButtonEnabled" (click)="openSignupModal()"
                    type="button">
                    Get OTP
                  </button>
                </div>
                <div class="note d-flex align-items-center mb-3">
                  <span class="icon">🔒</span>

                  <span> Your information is completely safe with us </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-verify-otp></app-verify-otp>